import { render, staticRenderFns } from "./supervise.vue.vue?vue&type=template&id=1f1c5144&scoped=true"
import script from "./supervise.vue.vue?vue&type=script&lang=js"
export * from "./supervise.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c5144",
  null
  
)

export default component.exports